import { render, staticRenderFns } from "./oes-widget.vue?vue&type=template&id=5135f4ed"
import script from "./oes-widget.vue?vue&type=script&lang=js"
export * from "./oes-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports